import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import './PrimaryButtonPurple.scss';

export default function PrimaryButtonPurple(props) {
    const className = 'button__primaryButtonPurple';

    const button = (
        <Button
            onClick={props.onClick}
            className={className + (props.disabled ? '__disabled' : '')}
            disabled={props.disabled}
            startIcon={props.startIcon}
            endIcon={props.endIcon}
            fullWidth={props.fullWidth}
            size={props.size || 'medium'}
            variant="contained">
            {props.text || props.children}
        </Button>
    );

    // Wrap with tooltip if tooltip text is provided
    if (props.tooltip) {
        return (
            <Tooltip 
                title={props.tooltip} 
                arrow 
                placement={props.tooltipPlacement || 'bottom'} 
                slots={{ transition: Zoom }}>
                <span style={{ width: props.fullWidth ? '100%' : 'fit-content' }}>
                    {button}
                </span>
            </Tooltip>
        );
    }

    return button;
}